import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";

const AdminApiService = new AdminApi()

export default {
    methods: {
        acceptTerms: acceptTerms,
        openRules: openRules
    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
    }
}

function acceptTerms() {
    AdminApiService.acceptTerms()
        .then((response) => {
            swal('Uspešno', 'Uslovi uspešno prihvaćeni. Uživajte :)', 'success')
            window.location = '/#' + CONFIG_COMPANY.HOME;
        })
        .catch(error => {
            console.log(error.response)
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function openRules() {
    this.$router.push('/rules');
}


// WEBPACK FOOTER //
// ./src/components/Account/AcceptTerms.js